import ApplicationModel from "../../../Apply/Models/ApplicationModel";
import { ExaminationGrade } from "../../../Examination/Enums/ExaminationGrade";
import Order from "../../../Shared/Models/Order";
import { PearsonVueAppointment } from "./PearsonVueAppointment";

export class AppliedToExamination {
    examinationId: number;
    examineeId: number;
    title: string;
    applicationLateDeadlineDate: string;
    applicationDeadlineDate: string;
    extensionDate: string;
    startDate: string;
    endDate: string;
    releaseGrades: boolean;
    showExamineeStatus: boolean;
    application: ApplicationModel;
    appointments: Array<PearsonVueAppointment>;
    examinationGrade: ExaminationGrade;
    examineeStatus: ExamineeStatus;
    examineeStatusDescription: string;
    examineeStatusReasonId: ExamineeStatusReason;
    examineeStatusReason: string;
    order: Order;
    formattedCnpType: string;
    moduleSelection: string;
    isConfirmingDelete: boolean;
    hasDeadlineException: boolean;
    isReEntry: boolean;
    isArticleBased: boolean;
    isGradingComplete : boolean;
    isExamFeePaid: boolean;
}



export enum ExamineeStatus {
    NA = 0,
    AuthorizationPending = 2,
    Authorized = 3,
    GradingComplete = 4,
    Delivered = 25,
    UnexcusedAbsence = 26
}

export enum ExamineeStatusReason {
    NoShow = 1,
    Invalidated = 3
}